import { useCallback } from 'react';

import { useTracking as useTrackingBase } from '@change-corgi/core/react/tracking';

import { useDeferredTrack } from 'src/app/shared/hooks/tracking';

type Result = {
	trackShouldSavePaymentMethodInputClick: () => void;
	trackShouldSavePaymentMethodInputFocus: () => void;
};

export function useTracking(): Result {
	const track = useTrackingBase();
	const deferredTrack = useDeferredTrack();

	return {
		trackShouldSavePaymentMethodInputClick: useCallback(() => {
			deferredTrack('pp_payment_save_payment_optin_clicked');
		}, [deferredTrack]),

		trackShouldSavePaymentMethodInputFocus: useCallback(() => {
			void track('pp_focus_save_payment');
		}, [track]),
	};
}
